import { render, staticRenderFns } from "./UpdateStudent.vue?vue&type=template&id=04990d1a&scoped=true"
import script from "./UpdateStudent.vue?vue&type=script&lang=js"
export * from "./UpdateStudent.vue?vue&type=script&lang=js"
import style0 from "./UpdateStudent.vue?vue&type=style&index=0&id=04990d1a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04990d1a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04990d1a')) {
      api.createRecord('04990d1a', component.options)
    } else {
      api.reload('04990d1a', component.options)
    }
    module.hot.accept("./UpdateStudent.vue?vue&type=template&id=04990d1a&scoped=true", function () {
      api.rerender('04990d1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/school/UpdateStudent.vue"
export default component.exports